import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import {
  AppVersionDifferences,
  ComparedResource,
} from '@flowx/designer/modules/merge-conflicts/merge-conflicts.dictionary'
import { versionResourceChangeStatusOrder } from '@flowx/designer/modules/version-changes/version-changes.utils'
import { FlxSpinnerModule } from '@flowx/designer/shared/components/spinner'
import { VersionResourceChangeStatus } from '@flowx/designer/shared/entities/application.entity'
import {
  ManifestResourceType,
  ManifestResourceTypeMapper,
} from '@flowx/designer/shared/entities/manifest-resource-type.entity'
import {
  buildResourceBreadcrumb,
  getResourceDisplayName,
} from '@flowx/designer/shared/utils/application-resource.utils'

@Component({
  selector: 'flx-version-changes',
  imports: [FlxIconModule, FlxSpinnerModule, FlxButtonModule, TooltipModule],
  templateUrl: './version-changes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'flex flex-col flex-1 min-h-0 overflow-y-auto overflow-x-hidden',
  },
})
export class FlxVersionChangesComponent {
  versionResources = input<AppVersionDifferences>({})
  loading = input<boolean>(false)
  emptyMessage = input<string>(null)
  showCompareButton = input<boolean>(true)
  selectedResourceForCompare = output<
    ComparedResource & { resourceChangeStatus: VersionResourceChangeStatus }
  >()
  versionResourceChangeStatusOrder = versionResourceChangeStatusOrder
  ManifestResourceType = ManifestResourceType
  resourceChangedNumber = computed(() => {
    const versionResources = this.versionResources()
    return Object.keys(versionResources).reduce((acc, curr) => {
      acc += versionResources[curr].length
      return acc
    }, 0)
  })

  versionResourcesWithTranslations = computed(() => {
    const versionResources = this.versionResources()
    return Object.keys(versionResources).reduce((acc, curr) => {
      acc[curr] = versionResources[curr].map((element) => ({
        ...element,
        breadcrumb: buildResourceBreadcrumb(element.metadataType || element.resourceType),
        name: getResourceDisplayName(
          element.metadataType || element.resourceType,
          element.resourceName || ManifestResourceTypeMapper[element.metadataType]?.plural
        ),
      }))

      return acc
    }, {})
  })

  selectResourceForCompare(
    item: Partial<ComparedResource>,
    resourceChangeStatus: VersionResourceChangeStatus
  ): void {
    this.selectedResourceForCompare.emit({ ...item, resourceChangeStatus })
  }
}
